import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { ReactComponent as RookieStarIcon }  from '../assets/icons/ranks/rookie-star.svg';
import { ReactComponent as BronzeStarIcon }  from '../assets/icons/ranks/bronze-star.svg';
import { ReactComponent as SilverStarIcon }  from '../assets/icons/ranks/silver-star.svg';
import { ReactComponent as GoldStarIcon }    from '../assets/icons/ranks/gold-star.svg';
import { ReactComponent as PlatinumHexIcon } from '../assets/icons/ranks/platinum-hexagon.svg';

import { TierObject } from '../types';
import { resolveTierColor, RANK_TIER_COLORS, RankTierColor } from '../constants/rankColors';

interface RankBadgeProps {
  /** サーバから来た TierObject（color/name を優先採用） */
  tier?: TierObject | null;
  /** 表示サイズ（アイコン径）。デフォルト 22 */
  size?: number;
  /** ティア名ラベルをアイコンの右に表示するか（既定 true） */
  showLabel?: boolean;
  /** ラベル文字サイズ */
  labelFontSize?: number | string;
}

const RankIconComponent: React.FC<{ code?: string | null; size: number }> = ({ code, size }) => {
  const style = { width: size, height: size, flexShrink: 0, display: 'block' };
  switch (code) {
    case 'gold':     return <GoldStarIcon     style={style} />;
    case 'silver':   return <SilverStarIcon   style={style} />;
    case 'bronze':   return <BronzeStarIcon   style={style} />;
    case 'platinum': return <PlatinumHexIcon  style={style} />;
    case 'rookie':   return <RookieStarIcon   style={style} />;
    default:         return null;
  }
};

const RankBadge: React.FC<RankBadgeProps> = ({
  tier,
  size = 22,
  showLabel = true,
  labelFontSize = '13px',
}) => {
  const code = tier?.code;
  const main = resolveTierColor(code, tier?.color);
  const fallback: RankTierColor | undefined = code ? RANK_TIER_COLORS[code] : undefined;
  const label = tier?.name ?? fallback?.label ?? 'クルー';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <RankIconComponent code={code} size={size} />
      {showLabel && (
        <Typography
          component="span"
          sx={{ fontWeight: 700, fontSize: labelFontSize, color: main, lineHeight: 1 }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default RankBadge;
